<!--
 * @Descripttion: 
 * @version: 
 * @Author: renqiang_hu
 * @Date: 2021-03-19 17:38:30
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-01-04 14:13:16
 * @FilePath: \heshan_web\src\views\deviceMonitor\sendCmdLog.vue
-->
<template>
 <div class="sendCmdLog">
     <div style="display:flex;align-items:center">
         <span>{{$t('sendCmdLog.queryMethod')}}：</span>
         <el-select v-model="value" :placeholder="$t('dataAnalysis.pleCho')">
            <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
            </el-option>
        </el-select>
        <el-input style="width:15%;margin-left:15px" v-model="devCode" v-if='value==1' :placeholder="$t('sendCmdLog.pleAddCode')"></el-input>
         <div v-if='value==2&&proname' class="proname"><span>{{$t('manipulation.devName')}}：{{proname}} &nbsp; {{$t('manipulation.airNum')}}：{{devnum}}</span></div>
         <prowerSetting v-if='value==2' @selectStation="selectStation" :onLine='onLine' style="margin-left:20px"/></div>
         <div style="display:flex;align-items:center;margin-top:20px">
              <span>{{$t('sendCmdLog.date')}}：</span>
              <el-date-picker
                v-model="value1"
                @change="changedate"
                type="datetimerange"
                :picker-options="pickerOptions"
                :range-separator="$t('sendCmdLog.arrive')"
                :start-placeholder="$t('sendCmdLog.startDate')"
                :end-placeholder="$t('sendCmdLog.endDate')">
                </el-date-picker>
                 <el-button type="primary" style="margin-left:15px" @click="seach">{{$t('dataAnalysis.inquire')}}</el-button>
                <el-button type="success" @click="result">{{$t('dataAnalysis.reset')}}</el-button>
         </div>
     <avue-crud :option="option" 
     :data="data" :page.sync="page" style="height:100%;overflow:auto" @size-change="sizeChange" @current-change="currentChange">></avue-crud>
 </div>
    
</template>
<script>
import {commandPage} from "@/api/devicemon"
import prowerSetting from '@/components/power/prowerSetting';
import moment from 'moment'
export default {
    name:'sendCmdLog',
    data(){
        return{
            page: {
                currentPage: 1,
                total: 0,
                layout: "total,pager,prev, next",
                background:true,
                pageSize: 10
            },
            form:{
 
                beginTime:'',
                endTime:''
            },
            value1:'',
            onLine:true,
            devCode:'',
            value:'1',
            options:[
                {
                    value: '1',
                    label: this.$t('sendCmdLog.addCodeQuery')
                },{
                    value: '2',
                    label: this.$t('sendCmdLog.levelQuery')
                }
            ],
           option: {
               
                searchMenuSpan:4,
                refreshBtn:false,
                align:'center',
                columnBtn:false,
                addBtn:false,
               
                menu:false,
                column: [{
                    label: this.$t('realdetile.serNum'),
                    prop: 'index',
                }, {
                    label: this.$t('manipulation.devName'),
                    prop: 'projectName',
                },{
                    label: this.$t('manipulation.deviceAdressNum'),
                    prop: 'devCodeDec',
                    // labelWidth: "100px",
                    // searchLabelWidth:100,
                    // searchSpan:8,
                    // search:true,
                   
                }, {
                    label: this.$t('manipulation.airNum'),
                    prop: 'devNumber',
                },
                
                {
                    label: this.$t('manipulation.date'),
                    prop: 'time',
                    type:'datetime',
                    // searchSpan:8,
                    // searchRange:true,
                    // search:true,
                },{
                    label: this.$t('sendCmdLog.actContent'),
                    prop: 'content',
                },{
                    label: this.$t('sendCmdLog.actResult'),
                    prop: 'state',
                },{
                    label: this.$t('sendCmdLog.actPeople'),
                    prop: 'operator',
                }
                
            ]
           },
           data:[
              
           ],
            pickerOptions: {
          shortcuts: [{
            text: this.$t('sendCmdLog.today'),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', [start, end]);
            }},{
            text: this.$t('sendCmdLog.lastWeek'),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: this.$t('sendCmdLog.lastMonth'),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, ]
        },
       
           proname:"",
           devnum:'',
           deviceId:''
        }
    },
    components:{
        prowerSetting
    },
    mounted(){
        this.getcommandPage()
    },
    methods:{
        result(){
             this.page.currentPage = 1
             this.value1 = ''
             this.value = '1'
             this.form ={
                  beginTime:'',
                  endTime:''
             }
             this.devCode = ''
              this.getcommandPage()
        },
        seach(){
            let obj = {
                devCodeDec:this.value==='1'?this.devCode:'',
                deviceId:this.value==='1'?"":this.deviceId,
                ...this.form
            }
            this.getcommandPage(obj)
        },
        changedate(val){
              this.form.beginTime = moment(val[0]).format("YYYY-MM-DD HH:mm:ss")
              this.form.endTime = moment(val[1]).format("YYYY-MM-DD HH:mm:ss")
        },
        selectStation(data){
          
            this.proname = data[1].projectName
            this.devnum = data[0].devNumber
            this.deviceId = data[0].id
        },
       
        sizeChange(){

        },
        currentChange(va){
            this.page.currentPage = va
            this.getcommandPage()
        },
        getcommandPage(info){
            let obj ={current:this.page.currentPage,...info,size:10}
            commandPage(obj).then(res=>{
                if(res.data.code==200){
                    res.data.data.records.map((item,index)=>{
                        if(item.state==1){
                            item.state = this.$t('sendCmdLog.success')
                        }else{
                            item.state = this.$t('sendCmdLog.fault')
                        }
                        item.index = index +1
                    })
                    this.data = res.data.data.records
                    this.page.total = res.data.data.total
                }
            })
        },
    }
}
</script>
<style lang="scss">
.sendCmdLog{
    padding: 16px !important;
}
    .proname{
        border:1px solid #ccc;
        padding: 5px 20px;
        border-radius: 5px;
        margin-left: 15px;
        
    }
</style>